import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';

const service = {

  async getUserList(params) {
    const endPoint = `user/getUserList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async saveUser(payload) {
    const endPoint = `user/saveUser`;
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async getUserById(params) {
    const endPoint = `user/findUserById`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params
    );
    return result;
  },

  async deleteUser(params) {
    const endPoint = `user/delete?id=${params.userId}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateUser(payload) {
    const endPoint = `user/updateUser?userId=${payload.userId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getUserWithSearch(params) {
    const endPoint = `user/findUserSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },
};

export default service;
